// import 'babel-polyfill'
import React from 'react'
import ReactDOM from 'react-dom'
import MfEmiPlotter from '../components/MfEmiPlotter'

document.addEventListener('DOMContentLoaded', () => {
  const nodes = document.getElementsByClassName('react-mf-emi-plotter')
  for(let i = 0; i < nodes.length; i++) {
    const node = nodes[i]
    const data = JSON.parse(node.getAttribute('data'))

    ReactDOM.render(<MfEmiPlotter {...data} />, node)
  }
})
